export default __webpack_public_path__ + "static/media/material-ui.93668437.png";